import { render } from "./BlockObject.vue?vue&type=template&id=a8fbee40"
import script from "./BlockObject.vue?vue&type=script&lang=js"
export * from "./BlockObject.vue?vue&type=script&lang=js"

import "./BlockObject.vue?vue&type=style&index=0&id=a8fbee40&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__